import Link from "next/link";
import { useCallback } from "react";
import { button, link, pageview } from "@qoohoo/common/constants/analytics";
import * as Track from "@qoohoo/common/utils/analytics/track";
import cls from "classnames";

const CreatorFooter = ({
  bgColor,
  fgColor,
  isLightMode,
  isWhiteTheme = false,
  showLinks = true,
  settings={},
  className
}) => {
  const current_screen = "footer";

  const copyrightMsg = settings?.copyright;

  const qoohooBranding = (
      <Link
      className="flex flex-row items-center justify-center group"
        href="/"
        onClick={useCallback(() =>
          Track.linkClick(link.qoohoo_logo, {
            url: "/",
            current_screen,
          })
        )}
      >
            <span className={cls(
              'text-sm mr-1.5 opacity-75 dark:text-[#16191B] group-hover:opacity-90 whitespace-nowrap',
              fgColor ? `text-${fgColor}` : isLightMode ? 'text-[#16191B]' : 'text-[#929292]'
            )}>Powered by</span>
        <QoohooIcon
          className={cls(
            "w-auto select-none h-[1.125rem] opacity-75 group-hover:opacity-90",
            fgColor ?
              `text-${fgColor}`
              :
              isWhiteTheme || isLightMode
                ? "text-[#16191B]"
                : "text-[#FFFFFF]"
          )}
        />
      </Link>
  );

  return (
    <footer className={cls(
      "font-nunito text-sm",
      bgColor ? `bg-${bgColor}` : "bg-[#121516]",
      fgColor ? `text-${fgColor}` : isLightMode ? "text-[#16191b]" : "text-[#929292]",
      isLightMode
        ? ""
        : "dark:bg-[#F5F5F5] dark:border-t dark:border-[#D5D8DC]"
    )}>
      <hr className="opacity-[0.12]" />
      <div className={cls("px-6 pt-5 pb-8 sm:py-8", className)}>
        <div className="flex flex-col sm:flex-row justify-between items-center max-w-[684px] md:max-w-[1120px] mx-auto">
          {copyrightMsg}
          {!settings?.is_white_labeled && qoohooBranding}
          {showLinks && (
            <ul className="text-sm mt-8 sm:mt-0 flex items-center dark:text-[#16191B] dark:hover:text-[#000000]">
              <li className="mx-2 sm:mx-4">
                <Link
                  href="/pages/privacy"
                  target="_blank"
                  rel="noopener"
                  className="opacity-75 hover:opacity-90"
                  onClick={useCallback(() =>
                    Track.linkClick(link.privacy_policy, {
                      url: "/privacy",
                      current_screen,
                    })
                  )}
                >
                  Privacy Policy
                </Link>
              </li>
              <li className="mx-2 sm:mx-4">
                <Link
                  href="/pages/stdeula"
                  target="_blank"
                  rel="noopener"
                  className="opacity-75 hover:opacity-90"
                  onClick={useCallback(() =>
                    Track.linkClick(link.terms_conditions, {
                      url: "/stdeula",
                      current_screen,
                    })
                  )}
                >
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          )}
        </div>
      </div>
    </footer>
  );
};

export const QoohooIcon = ({ className }) => (
  <svg
    width="124"
    height="34"
    viewBox="0 0 124 34"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.12039 6.5362C3.94796 6.5362 4.74164 6.20719 5.32683 5.62155C5.91202 5.03591 6.24077 4.24161 6.24077 3.41339C6.24077 2.58517 5.91202 1.79087 5.32683 1.20523C4.74164 0.619593 3.94796 0.290585 3.12039 0.290585C2.29281 0.290585 1.49913 0.619593 0.91394 1.20523C0.328754 1.79087 0 2.58517 0 3.41339C0 4.24161 0.328754 5.03591 0.91394 5.62155C1.49913 6.20719 2.29281 6.5362 3.12039 6.5362ZM31.1674 6.5C28.519 6.5 26.2875 7.40746 24.4374 9.24147C22.6048 11.0569 21.6799 13.3082 21.6799 15.9773C21.6799 18.6463 22.6048 20.8976 24.4369 22.7312C26.2699 24.5647 28.519 25.4726 31.1679 25.4726C33.8168 25.4726 36.0478 24.5652 37.8985 22.7312C39.7487 20.8976 40.674 18.6644 40.674 15.9773C40.674 13.2901 39.7492 11.0569 37.8985 9.22337C36.0478 7.40746 33.7983 6.5 31.1674 6.5ZM35.7037 20.5523C34.4694 21.787 32.9638 22.3863 31.1674 22.3863C29.3901 22.3863 27.884 21.7689 26.6688 20.5523C25.435 19.318 24.8362 17.7932 24.8362 15.9773C24.8362 14.1433 25.4531 12.6184 26.6688 11.4018C27.9021 10.167 29.3901 9.56826 31.1679 9.56826C32.9639 9.56826 34.488 10.1856 35.7032 11.4018C36.937 12.6365 37.5358 14.1618 37.5358 15.9773C37.5358 17.8108 36.9375 19.3361 35.7037 20.5523ZM10.0504 6.5C7.40196 6.5 5.1705 7.40746 3.32031 9.24147C1.48772 11.0569 0.562388 13.3082 0.562388 15.9773C0.562388 18.6463 1.48772 20.8976 3.32031 22.7312C5.15241 24.5647 7.40196 25.4726 10.0509 25.4726C12.6993 25.4726 14.9308 24.5652 16.7815 22.7312L16.8905 22.6221L14.9669 33.2979H19.557V15.9773C19.557 13.3082 18.6316 11.0569 16.7815 9.22337C14.9308 7.40746 12.6998 6.5 10.0504 6.5ZM14.5866 20.5523C13.3524 21.787 11.8468 22.3863 10.0504 22.3863C8.27304 22.3863 6.76699 21.7689 5.55178 20.5523C4.318 19.318 3.71919 17.7932 3.71919 15.9773C3.71919 14.1433 4.33608 12.6184 5.55178 11.4018C6.78507 10.167 8.27304 9.56826 10.0509 9.56826C11.8468 9.56826 13.3705 10.1856 14.5862 11.4018C15.8199 12.6365 16.4183 14.1618 16.4183 15.9773C16.4368 17.8108 15.8204 19.3361 14.5866 20.5523ZM52.285 6.5C49.6365 6.5 47.4051 7.40746 45.5544 9.24147C43.7223 11.075 42.797 13.3082 42.797 15.9954C42.797 18.6825 43.7223 20.9157 45.5544 22.7493C47.387 24.5833 49.6365 25.4907 52.285 25.4907C54.9339 25.4907 57.1654 24.5833 59.0155 22.7493C60.8662 20.9157 61.7915 18.6825 61.7915 15.9954C61.7915 13.3082 60.8662 11.075 59.0155 9.24147C57.1654 7.40746 54.9158 6.5 52.285 6.5ZM56.8202 20.5523C55.5869 21.787 54.0809 22.3863 52.285 22.3863C50.5071 22.3863 49.0016 21.7689 47.7859 20.5523C46.5521 19.318 45.9533 17.7932 45.9533 15.9773C45.9533 14.1433 46.5702 12.6184 47.7859 11.4018C49.0196 10.167 50.5071 9.56826 52.285 9.56826C54.0809 9.56826 55.605 10.1856 56.8202 11.4018C58.054 12.6365 58.6528 14.1618 58.6528 15.9773C58.6528 17.8108 58.0359 19.3361 56.8202 20.5523ZM73.6015 6.5C70.9892 6.5 69.03 7.51655 67.76 9.56826V0H64.6213V25.0006H67.76V15.4323C67.76 13.4168 68.2318 11.9101 69.1933 10.9478C70.1548 9.96745 71.4066 9.49537 72.985 9.49537C74.3816 9.49537 75.4702 9.89504 76.2685 10.712C77.0667 11.5109 77.4661 12.6546 77.4661 14.1252V25.0187H80.6043V13.9256C80.6043 11.6381 79.9693 9.84074 78.6994 8.49691C77.4113 7.15357 75.7244 6.5 73.6015 6.5ZM92.5599 6.5C89.9109 6.5 87.6795 7.40746 85.8293 9.24147C83.9967 11.075 83.0714 13.3082 83.0714 15.9954C83.0714 18.6825 83.9967 20.9157 85.8293 22.7493C87.6614 24.5833 89.9109 25.4907 92.5599 25.4907C95.2083 25.4907 97.4398 24.5833 99.2904 22.7493C101.141 20.9157 102.066 18.6825 102.066 15.9954C102.066 13.3082 101.141 11.075 99.2904 9.24147C97.4398 7.40746 95.2083 6.5 92.5599 6.5ZM97.0951 20.5523C95.8613 21.787 94.3558 22.3863 92.5599 22.3863C90.782 22.3863 89.276 21.7689 88.0608 20.5523C86.827 19.318 86.2282 17.7932 86.2282 15.9773C86.2282 14.1433 86.8451 12.6184 88.0608 11.4018C89.2941 10.167 90.782 9.56826 92.5599 9.56826C94.3558 9.56826 95.8794 10.1856 97.0951 11.4018C98.3289 12.6365 98.9272 14.1618 98.9272 15.9773C98.9458 17.8108 98.3289 19.3361 97.0951 20.5523ZM120.407 9.24098C118.557 7.40746 116.307 6.5 113.677 6.5C111.028 6.5 108.797 7.40746 106.946 9.24147C105.114 11.075 104.189 13.3082 104.189 15.9954C104.189 18.6825 105.114 20.9157 106.946 22.7493C108.778 24.5833 111.028 25.4907 113.677 25.4907C116.325 25.4907 118.557 24.5833 120.407 22.7493C122.258 20.9157 123.183 18.6825 123.183 15.9954C123.183 13.3082 122.258 11.0564 120.407 9.24098ZM118.212 20.5523C116.979 21.787 115.473 22.3863 113.677 22.3863C111.899 22.3863 110.393 21.7689 109.178 20.5523C107.944 19.318 107.345 17.7932 107.345 15.9773C107.345 14.1433 107.962 12.6184 109.178 11.4018C110.411 10.167 111.899 9.56826 113.677 9.56826C115.473 9.56826 116.997 10.1856 118.212 11.4018C119.446 12.6365 120.045 14.1618 120.045 15.9773C120.045 17.8108 119.446 19.3361 118.212 20.5523Z"
      fill="currentColor"
    />
  </svg>
);

export default CreatorFooter;
